import React, { useState, useEffect } from 'react';
import { palettes, Textarea } from '@indigo-ag/component-module';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPaperclip } from '@fortawesome/pro-regular-svg-icons';
import i18next from 'core/i18n';

import { createStylesHook } from 'shared/hooks/createStylesHook';
import { ModalOptionsMenu } from 'features/brazil-grower/components/BrazilGrowerDocuments/BrazilGrowerDocumentsList/EditDocumentModal/ModalOptionsMenu';

const useStyles = createStylesHook(({ typography: { pxToRem } }) => ({
  containerList: {
    marginBottom: pxToRem(15),
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    height: pxToRem(48),
    padding: pxToRem(16),
    border: '1px solid #ACC0CA'
  },
  lineDivider: {
    height: pxToRem(1),
    background: '#D7E4E9',
    marginBottom: pxToRem(16)
  },
  textAreaStyles: {
    margin: '18px 0px 16px 40px !important'
  },
  fileName: {
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    marginLeft: pxToRem(6),
    marginRight: pxToRem(6)
  }
}));

interface UploadDocumentItemProps {
  removeFileAction: () => void;
  file: File;
  replaceItem: any;
  onUpdateFile: any;
}

export const UploadDocumentItem: React.FunctionComponent<UploadDocumentItemProps> = ({
  removeFileAction,
  file,
  replaceItem,
  onUpdateFile
}) => {
  /**
   * State
   */
  const [commentFieldActive, setCommentFieldActive] = useState(false);
  const [comment, setComment] = useState('');

  /**
   * Styles
   */
  const classes = useStyles();

  useEffect(() => {
    setComment(file['comment'] || '');
  }, [file['comment']]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleComment = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    if (file.type.length > 0) {
      setComment(e.target.value);
      file['comment'] = e.target.value;
      return;
    } else {
      setComment(e.target.value);
      file['comment'] = e.target.value;
      if (file['isNew']) {
        replaceItem(file);
      } else {
        onUpdateFile(file);
      }
    }
  };

  const toggleCommentField = (): void => setCommentFieldActive(!commentFieldActive);

  return (
    <>
      <div className={classes.containerList}>
        <FontAwesomeIcon icon={faPaperclip} size="lg" style={{ color: palettes.coastal.core.mediumBlue }} />
        <span title={file.name} className={`${classes.fileName}`}>
          {file.name}
        </span>
        <div className="ml-auto">
          <ModalOptionsMenu
            addCommentAction={toggleCommentField}
            isDisabled={comment.length > 0}
            removeFileAction={removeFileAction}
          />
        </div>
      </div>
      {commentFieldActive || comment.length > 0 ? (
        <Textarea
          className={classes.textAreaStyles}
          label={i18next.t('comment')}
          onChange={handleComment}
          resizable
          value={comment || ''}
        />
      ) : null}

      {file && commentFieldActive ? <div className={classes.lineDivider}></div> : null}
    </>
  );
};
